import React from "react";
import { ConfigProvider } from "antd";
import locale from "antd/locale/en_GB";
import { Provider } from "react-redux";

import { antdTheme } from "config/antd-theme";

import store from "../../../redux/store";

const RootProviders = ({ children }) => {
  return (
    <Provider store={store}>
      <ConfigProvider theme={antdTheme} locale={locale}>
        {children}
      </ConfigProvider>
    </Provider>
  );
};

export default RootProviders;
